
const localesReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case 'GET_LANGUAGE': {
            return {
                ...state,
                lang: payload
            }
        }

        case 'GET_LOCALE_RESOURCE_PATH': {
            return {
                ...state,
                path: payload
            }
        }

        case 'GET_CURRENT_LANGUAGE': {
            return {
                ...state,
                language: payload
            }
        }

        case 'LANGUAGE_SWITCH_ITEM': {
            return {
                ...state,
                items: payload
            }
        }

        default:
            return state;
    }

}

export default localesReducer;